module.exports = __webpack_public_path__ + "img/content-desktop.60bb673f.png";